<template>
  <div class="pt-8 flex flex-col lg:flex-row p-4 min-h-screen bg-light-bg dark:bg-dark-bg dark:text-dark-text">
    <AppSidebar />

    <div class="flex flex-col flex-grow p-6 lg:p-12 space-y-4 h-full">
      <!-- Wiadomość sukcesu lub błędu -->
      <div v-if="message" :class="messageType" 
          class="fixed top-0 left-0 right-0 z-5 p-4 rounded-lg mb-4 text-center 
                  bg-white dark:bg-dark-box-bg dark:text-dark-text dark:border 
                  dark:border-dark-border">
          {{ message }}
          <div class="absolute bottom-0 left-0 h-1 rounded-lg" 
              :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }">
          </div>
      </div>

      <h1 class="text-xl md:text-2xl font-bold mb-4 text-center lg:text-left">Hotele</h1>

      <HotelCreateModal
          :isOpen="isModalOpen"
          @close="closeModal"
          @submit="handleOrderSubmit"
      />

      <HotelEditModal
          :isOpen="isEditModalOpen"
          :hotelToEdit="editingHotel"
          @close="closeEditModal"
          @submit="handleOrderEditSubmit"
      />

      <div class="bg-white p-4 rounded-lg shadow-md w-full h-auto overflow-visible dark:bg-dark-box-bg dark:border dark:border-dark-border">
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between mb-4">
          <h2 class="text-lg font-semibold text-gray-700 dark:text-dark-text">Lista Hoteli:</h2>

          <DynamicSearch
              :data="hotels"
              :keysToSearch="['name', 'address']"
              @search-results="handleSearchResults"
              @clear-search="clearSearch"
              class="mt-4 bg-gray-200 dark:bg-dark-box-bg text-gray-900 dark:text-dark-text w-full md:w-auto"
              placeholder="Wyszukaj..."
          />
        </div>

        <div class="overflow-x-auto w-full">
          <table class="min-w-full bg-white border border-gray-300 rounded-lg dark:bg-dark-table-bg dark:border-dark-border">
            <thead>
            <tr class="bg-gray-50 dark:bg-dark-table-header">
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Nazwa hotelu
              </th>
              <th class="py-3 px-4 border-b border-gray-300 dark:border-dark-border text-left text-sm font-semibold text-gray-700 dark:text-dark-text">
                Adres hotelu
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="pagedHotels.length === 0">
              <td colspan="3" class="text-center py-4 text-red-500 font-semibold dark:text-dark-status-unavailable">
                Brak Hoteli
              </td>
            </tr>
            <tr
                v-else
                v-for="(hotel) in pagedHotels"
                :key="hotel.id"
                :class="[
                    'border-b border-gray-300 dark:border-dark-border hover:bg-light-hover dark:hover:bg-dark-hover hover:cursor-pointer',
                    selectedHotel && hotel.id === selectedHotel.id ? 'bg-light-hover dark:bg-dark-hover' : ''
                ]"
                @click="showStationDetails(hotel)"
            >
              <td class="py-3 px-4 dark:text-dark-text">{{ hotel.name }}</td>
              <td class="py-3 px-4 dark:text-dark-text">{{ hotel.address }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginacja -->
        <div class="mt-4 flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
          <div class="text-center sm:text-left text-sm text-light-text dark:text-gray-400">
            Wyświetlono {{ (currentPage - 1) * itemsPerPage + pagedHotels.length }} z {{ filteredHotels.length }} stacji
          </div>


          <div class="flex flex-wrap justify-center sm:justify-end items-center gap-2">
            <button v-if="currentPage > 1"
                    @click="goToPage(1)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Pierwsza strona
            </button>
            <button v-if="currentPage > 1"
                    @click="prevPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              &laquo; Poprzednia
            </button>
            <button v-for="page in visiblePages"
                    :key="page"
                    @click="goToPage(page)"
                    :class="[currentPage === page ? 'bg-teal-700 text-white' : 'bg-gray-200 dark:bg-dark-box-bg text-gray-700 dark:text-dark-text']"
                    class="px-3 py-1 text-sm font-medium rounded-md transition-colors hover:bg-teal-700 hover:text-white dark:hover:bg-teal-600 dark:hover:text-white">
              {{ page }}
            </button>
            <button v-if="currentPage < totalPages"
                    @click="nextPage"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Następna &raquo;
            </button>
            <button v-if="currentPage < totalPages"
                    @click="goToPage(totalPages)"
                    class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
              Ostatnia strona
            </button>
          </div>
        </div>
      </div>

      <button
          @click="openModal"
          class="fixed bottom-8 right-8 bg-button-bg text-button-text p-4 rounded-full shadow-md transition-transform duration-200 ease-in-out hover:bg-button-hover dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
      >
        <PlusIcon class="h-6 w-6 transition-transform duration-200 ease-in-out transform hover:rotate-45" />
      </button>
    </div>
  </div>

  <HotelnformationModal
            v-if="showModal"
            :visible="showModal"
            :title="'Szczegóły Hotelu #' + (selectedHotel?.id || '')"
            :selectedHotel="selectedHotel"
            :userRole="user.role"
            @close="closeModalInformation"
            @startEditing="startEditing"
            @deleteHotel="deleteHotel"
      >
          <div class="space-y-4">
            <p><b>Nazwa hotelu:</b> {{ selectedHotel?.name }}</p>
            <p><b>Adres hotelu:</b> {{ selectedHotel?.address }}</p>
          </div>
  </HotelnformationModal>
</template>


<script>
import AppSidebar from '../AppSidebar.vue';
import DynamicSearch from '../search/DynamicSearch.vue';
import { PlusIcon } from "@heroicons/vue/24/solid";
import { useAuthStore } from '@/stores/authStore';
import HotelCreateModal from './HotelCreateModal.vue';
import HotelnformationModal from './HotelnformationModal.vue';
import HotelEditModal from './HotelEditModal.vue';
import hotelService from '@/services/hotelService';

export default {
    name: 'StationsPageDispatcher',
    components: {
        AppSidebar,
        DynamicSearch,
        PlusIcon,
        HotelEditModal,
        HotelCreateModal,
        HotelnformationModal,
    },
    setup() {
        const authStore = useAuthStore();
        authStore.checkExpiration();
        return { user: authStore.user, authStore };
    },
    data() {
        return {
            hotels: [],
            filteredHotels: [],
            editingHotel: null,
            isModalOpen: false,
            isEditModalOpen: false,
            message: '',
            messageType: '',
            currentPage: 1,
            itemsPerPage: 5,
            progress: 0,
            dropdownOpen: null,
            loading: false,
            showModal: false,
            selectedHotel: null,
            isSecureContext: false,
        };
    },
    mounted() {
      this.calculateItemsPerPage();
      window.addEventListener("resize", this.calculateItemsPerPage);

      this.fetchHotels();

      setInterval(() => {
        if (!this.isSearching) {
          this.fetchHotels();
        }
      }, 10000); // Odświeżanie co 10 sekund
    },
    beforeUnmount() {
      window.removeEventListener("resize", this.calculateItemsPerPage);
    },
    computed: {
        pagedHotels() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredHotels.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.filteredHotels.length / this.itemsPerPage);
        },
        visiblePages() {
            const maxVisible = 5; // Maksymalna liczba widocznych stron
            const startPage = Math.max(this.currentPage - Math.floor(maxVisible / 2), 1);
            const endPage = Math.min(startPage + maxVisible - 1, this.totalPages);

            const pages = [];
            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    methods: {
        calculateItemsPerPage() {
          const width = window.innerWidth;

          if (width >= 3840) {
            this.itemsPerPage = 24; // 4K monitor
          } else if (width >= 2560) {
            this.itemsPerPage = 15; // 2K monitor
          } else if (width >= 1920) {
            this.itemsPerPage = 8; // Full HD monitor
          } else {
            this.itemsPerPage = 5; // Standardowa wartość
          }

          this.calculateTotalPages();
        },
        calculateTotalPages() {
          this.totalPages = Math.ceil(this.filteredHotels.length / this.itemsPerPage) || 1;
          this.updateVisiblePages();
        },
        updateVisiblePages() {
          const range = 5; // Liczba widocznych stron
          const start = Math.max(1, this.currentPage - Math.floor(range / 2));
          const end = Math.min(start + range - 1, this.totalPages);

          this.visiblePages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
        },
        showStationDetails(hotel) {
          this.selectedHotel = hotel; // Przypisz wybrane zamówienie
          this.showModal = true; // Pokaż modal
        },
        closeModalInformation() {
          this.selectedHotel = null; // Wyczyść dane zamówienia
          this.showModal = false; // Zamknij modal
        },
        handleSearchResults(filteredData) {
            this.filteredHotels = filteredData;
            this.currentPage = 1;

            this.isSearching = filteredData.length > 0;

            this.goToPage(1);
        },
        clearSearch() {
          this.isSearching = false;

          this.goToPage(1);
        },
        toggleDropdown(hotelId) {
            this.dropdownOpen = this.dropdownOpen === hotelId ? null : hotelId;
        },
        showMessage(msg, type) {
            this.message = msg;
            this.messageType = type === 'success' ? 'success-message' : 'error-message';
            this.progress = 0;

            const interval = 30;
            const duration = 5000;
            const step = 100 / (duration / interval);

            const progressInterval = setInterval(() => {
                this.progress += step;
                if (this.progress >= 100) {
                clearInterval(progressInterval);
                this.progress = 0;
                this.message = '';
                this.messageType = '';
                }
            }, interval);
        },
        openModal() {
            if (!this.isModalOpen) {
            this.isModalOpen = true;
            }
        },
        closeModal() {
            if (this.isModalOpen) {
            this.isModalOpen = false;
            }
        },
        handleOrderSubmit(newHotel) {
            if (!this.loading) {
                this.submitCreate(newHotel);
            }
        },
        startEditing(hotel) {
            this.showModal = false;
            this.openEditModal(hotel);
        },
        openEditModal(hotel) {
            this.editingHotel = hotel;
            this.isEditModalOpen = true;
        },
        closeEditModal() {
            this.isEditModalOpen = false;
            this.editingHotel = null;
        },
        handleOrderEditSubmit(editingHotel) {
            if (!this.loading) {
                this.submitEdit(editingHotel);
            }
        },
        async submitCreate(newHotel) {
            if (this.loading) return;

            this.loading = true;

            try {
                const hotelData = {
                    id: newHotel.id,
                    name: newHotel.name,
                    address: newHotel.address,
                };

                await hotelService.createHotel(hotelData);
                this.showMessage("Hotel został pomyślnie dodany.", "success");

                await this.fetchHotels();
                this.resetNewHotel();
                this.closeModal();
            } catch (error) {
                this.showMessage("Wystąpił błąd podczas dodawania hotelu.", "error");
                console.error('Błąd podczas tworzenia hotelu:', error);
            } finally {
                this.loading = false;
            }
        },
        async submitEdit(editingHotel) {
            if (this.loading) return;

            this.loading = true;
            try {
                const hotelData = {
                    id: editingHotel.id,
                    name: editingHotel.name,
                    address: editingHotel.address,
                };

                await hotelService.updateHotel(hotelData.id, hotelData);
                this.showMessage("Hotel został pomyślnie zaktualizowany.", "success");

                await this.fetchHotels();
                this.closeEditModal();
            } catch (error) {
                this.showMessage("Wystąpił błąd podczas aktualizacji hotelu.", "error");
                console.error('Błąd podczas aktualizacji hotelu:', error);
            } finally {
                this.loading = false;
            }
        },
        getProgressColor() {
            return this.messageType === 'success-message' ? '#16a34a' : '#b91c1c';
        },
        resetNewHotel() {
            this.newHotel = {
                name: '',
                address: '',
            };
        },
        async deleteHotel(hotelId) {
            if (confirm("Czy na pewno chcesz usunąć ten hotel?")) {
                try {
                    await hotelService.deleteHotel(hotelId);
                    await this.fetchHotels();
                    this.showMessage("Hotel został pomyślnie usunięty.", "success");
                    this.closeModalInformation();
                } catch (error) {
                    console.error('Błąd podczas usuwania hotelu:', error);
                    this.showMessage("Wystąpił błąd podczas usuwania hotelu.", "error");
                }
            }
        },
        async fetchHotels() {
            try {
                const response = await hotelService.getAllHotels();
                this.hotels = response.data;
                this.filteredHotels = this.hotels;
                this.loading = false;
            } catch (error) {
                this.errorMessage = 'Błąd podczas pobierania szczegółów hoteli. Spróbuj ponownie.';
                this.loading = false;
            }
        },
        goToPage(page) {
            if (page > 0 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
    }
}
</script>